import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  maPhieuMua: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  tenHangHoa: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  loHang: Yup.object()
    .shape({
      tenLoHang: Yup.string()
    })
    .nullable()
    .required(VALIDATE_MESSAGE.cscore_required)
});
